import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { Tab } from '@thd-olt-component-react/tab';
import { Col } from '@thd-olt-component-react/grid';
import { Heading } from '@thd-olt-component-react/heading';
import { WallAreaCalculator } from '@thd-olt-component-react/calculator';
import { Image } from '@thd-olt-component-react/image';
import { Button } from '@thd-olt-component-react/button';
import { EasyEstimator } from './EasyEstimator/EasyEstimator';
import { calculateSize } from '../../../data/paint-modals.json';
import styles from './ContainerSize.module.scss';

const cx = classNames.bind(styles);

export const ContainerSize = () => {

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('containerSize.ready');
  }, []);

  const tabGroupRef = React.createRef();
  const handleTabChange = () => {
    const { tabRefs } = tabGroupRef?.current;
    const easyEstimatorTabRef = {
      currentTarget: tabRefs?.[1]
    };

    tabGroupRef.current.onClickTab(easyEstimatorTabRef);
  };

  const introPane = (
    <>
      <Image
        className={cx('bucket-image')}
        src="https://assets.thdstatic.com/images/v1/paint/1-gallon-bucket.svg"
        alt="One Gallon Paint Bucket"
      />
      <div className={cx('instructions')}>
        Enter your room&apos;s measurements to get your results or check out the&nbsp;
        <Button
          inline
          onClick={handleTabChange}
          link
          className={cx('easy-estimate-link')}
          tag="a"
        >
          Easy Estimator
        </Button>&nbsp;for a more
        general estimate.
      </div>
    </>
  );

  const errorMessage = 'One or more fields have invalid input(s). Unable to calculate.';

  return (
    <div className={cx('container-size')}>
      <Heading
        title="Calculate or Estimate"
        className={cx('container-size__heading')}
      />
      <div className={cx('container-size__body')}>
        <Col sm="12" md="12" lg="12">
          <Tab.Group ref={tabGroupRef}>
            <Tab>
              <Tab.Title>Paint Calculator</Tab.Title>
              <Tab.Content>
                <WallAreaCalculator
                  className={cx('calculate-size-container')}
                  errorMessage={errorMessage}
                  introPane={introPane}
                  disclaimer={calculateSize.disclaimer}
                />
              </Tab.Content>
            </Tab>
            <Tab>
              <Tab.Title>Easy Estimator</Tab.Title>
              <Tab.Content>
                <EasyEstimator />
              </Tab.Content>
            </Tab>
          </Tab.Group>
        </Col>
      </div>
    </div>
  );
};

ContainerSize.displayName = 'ContainerSize';
